import { useState } from 'react'

function Section({ title, items }) {
    const [open, setOpen] = useState(false)
    return (
        <div className="accordion">
            <button className="accordion-title" onClick={() => setOpen(!open)}>
                <span>{title}</span>
                <span className="accordion-arrow">{open ? '▲' : '▼'}</span>
            </button>
            {open && (
                <div className="accordion-content">
                    {items.map((item, i) => (
                        <p key={i} className="ul-list">
                            <img src="/img/icons/blue-arrow.svg" className="blue-arr"/>
                            {item}
                        </p>
                    ))}
                </div>
            )}
        </div>
    )
}

function Electrique(){
    const sections = [
        {
            title: "Compétences techniques",
            items: [
                "Lecture et réalisation de schémas électriques basse tension",
                "Câblage de circuits 230V monophasés",
                "Installation et raccordement de relais de puissance",
                "Utilisation de porte-fusibles et protections électriques",
                "Réalisation de dérivations et raccordements sur borniers / Wago",
                "Contrôle de continuité et mesures au multimètre",
                "Diagnostic et recherche de pannes électriques",
                "Respect des règles de séparation BT / TBTS (230V / 5V)",
            ]
        },
        {
            title: "Électronique",
            items: [
                "Câblage et alimentation de cartes ESP32",
                "Intégration de modules électroniques embarqués",
                "Utilisation de convertisseurs AC/DC 230V → 5V",
                "Réalisation de soudures électroniques",
                "Distribution d'alimentation 5V et masses communes",
            ]
        },
        {
            title: "Mesure et contrôle",
            items: [
                "Mesure de tension secteur",
                "Mesure d'intensité par transformateur de courant (CT)",
                "Mesure de puissance électrique",
                "Mesure et suivi de consommation énergétique",
                "Acquisition de données en temps réel",
            ]
        },
        {
            title: "Informatique industrielle / domotique",
            items: [
                "Programmation ESP32 (Arduino)",
                "Développement d'une interface web embarquée",
                "Communication Wi-Fi",
                "Télécommande d'équipements électriques",
                "Supervision de consommation énergétique",
                "Développement de solutions IoT",
            ]
        },
    ]

    return(
        <article>
            {sections.map((s, i) => (
                <Section key={i} title={s.title} items={s.items} />
            ))}
        </article>
    )
}

export default Electrique
